// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"ZipCodeWall_singleCard__17itp","sub_Title":"ZipCodeWall_sub_Title__eSHiE","link":"ZipCodeWall_link__1wUZS"};